import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["categoryToggle", "childrenContainer"];

  static values = {
    options: Object
  };

  connect() {
    this.resetActiveClasses();
    this.addClickEventsToMenuItems();

    this.activePath = [];
  }

  toggleChildren(event) {
    event.preventDefault();

    const clickedToggle = event.currentTarget;
    const clickedId = clickedToggle.dataset.categoryId;
    const clickedLevel = parseInt(clickedToggle.dataset.level);

    this.activePath = this.getFullPath(clickedId);

    this.updateActiveClasses();

    this.childrenContainerTargets.forEach(container => {
      const level = parseInt(container.dataset.level);
      if (level >= clickedLevel + 1) {
        container.style.display = "none";
      }
    });

    const containerToShow = this.childrenContainerTargets.find(
      container => container.dataset.parentId === clickedId
    );

    if (containerToShow) {
      containerToShow.style.display = "flex";

      const overviewItem = this.createOverviewItem(clickedId);
      const list = containerToShow.querySelector("ul");

      if (list) {
        list.querySelectorAll(".menu-item--overview").forEach(el => el.remove());
        list.prepend(overviewItem);
      }
    }
  }

  addClickEventsToMenuItems() {
    const menuItems = this.element.querySelectorAll('li.menu-item');

    menuItems.forEach(menuItem => {
      const anchor = menuItem.querySelector('a.nav-menu-item-title[href]');

      if (anchor) {
        const hasChildren = anchor.dataset.hasChildren === 'true';
        const href = anchor.href;

        if (!hasChildren && href) {
          if (!menuItem.dataset.listenerAttached) {
            menuItem.classList.add('clickable');
            menuItem.style.cursor = 'pointer';

            menuItem.addEventListener('click', (e) => {
              if (e.target.tagName !== 'A') {
                window.location.href = href;
              }
            });

            menuItem.dataset.listenerAttached = 'true';
          }
        }
      }
    });
  }



  findParentId(categoryId) {
    const el = this.element.querySelector(`[data-category-id="${categoryId}"]`);
    const container = el?.closest("[data-parent-id]");
    return container?.dataset?.parentId || null;
  }

  getFullPath(categoryId) {
    const path = [];

    let currentId = categoryId;

    while (currentId) {
      path.unshift(currentId);

      const el = this.element.querySelector(`[data-category-id="${currentId}"]`);
      const container = el?.closest("[data-parent-id]");

      currentId = container?.dataset?.parentId || null;
    }

    return path;
  }
  resetActiveClasses() {
    this.element.querySelectorAll(".menu-item--current, .menu-item--current-parent")
      .forEach(item => {
        item.classList.remove("menu-item--current", "menu-item--current-parent");
      });
    this.activePath = [];
  }


  updateActiveClasses() {
    this.element.querySelectorAll(".menu-item--current, .menu-item--current-parent")
      .forEach(item => {
        item.classList.remove("menu-item--current", "menu-item--current-parent");
      });

    this.activePath.forEach((id, index) => {
      const li = this.element.querySelector(`li.menu-item[data-category-id="${id}"]`);
      if (!li) return;

      if (index === this.activePath.length - 1) {
        li.classList.add("menu-item--current");
      } else {
        li.classList.add("menu-item--current-parent");
      }
    });
  }

  createOverviewItem(categoryId) {
    const parentItem = this.element.querySelector(`li.menu-item[data-category-id="${categoryId}"]`);
    if (!parentItem) return "";

    const linkEl = parentItem.querySelector("a.nav-menu-item-title");
    if (!linkEl) return "";

    const name = linkEl.textContent.trim();
    const href = linkEl.getAttribute("href");

    if (!href) return "";

    const li = document.createElement("li");
    li.className = "menu-item menu-item--overview d-flex justify-content-between align-items-center";
    li.dataset.categoryId = categoryId;

    const a = document.createElement("a");
    a.className = "nav-menu-item-title overview-link";
    a.style.flexGrow = "1";

    const overviewLabel = this.optionsValue?.strings?.overview || "Overview";
    a.textContent = `${overviewLabel} ${name}`;

    if (href) a.setAttribute("href", href);

    if (href) {
      li.addEventListener("click", (e) => {
        if (e.target.tagName !== 'A') {
          const isProtocolJavascript = href.trim().toLowerCase().startsWith('javascript:');
          if (isProtocolJavascript) {
            console.warn("Blocked XSS:", href);
          } else {
            window.location.href = href;
          }
        }
      })

      li.style.cursor = "pointer";
    }

    li.appendChild(a);
    return li;
  }
}
